import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../helpers/export'
import ReportService from './ReportService'
import axios from 'axios'

export const getReportItems = createAsyncThunk(
  'companyAnalysis/businessCreditReport/getReportItems',
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportService.getReportItems(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const getSampleReport = createAsyncThunk(
  'companyAnalysis/businessCreditReport/getSampleReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ReportService.getSampleReport(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
